import { useLocSettings } from "../../hooks/SettingsHooks";
import ProductsFiltersItem from "./ProductsFiltersItem";
import {
  useBjelinTranslations,
  useSpecsTranslation
} from "../../hooks/TranslationHooks";
import Icon from "../Icon";
import { useState } from "react";
import classNames from "classnames";
import { AnimatePresence, motion } from "motion/react";
import "./style.scss";

const ProductsFilter = ({ filterField, data, activeFilters, setFilter }) => {
  const settings = useLocSettings();
  const t = useBjelinTranslations();
  const ts = useSpecsTranslation();
  const [expanded, setExpanded] = useState(!!activeFilters[filterField]);

  return (
    <div
      key={filterField}
      className={classNames("filter", { "filter-expanded": expanded })}
    >
      <button
        className="filter-header"
        id={"filter-" + filterField}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          setExpanded(expanded => !expanded);
        }}
        tabIndex={-1}
      >
        <div className="filter-label">{ts(filterField)}:</div>
        <AnimatePresence>
          {!expanded && (
            <>
              {activeFilters[filterField] ? (
                <motion.div
                  className="filter-value filter-value-active"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 20, transition: { damping: 1 } }}
                >
                  {activeFilters[filterField].map(af => (
                    <span key={af}>{ts(filterField, af)}</span>
                  ))}
                </motion.div>
              ) : (
                <motion.div
                  className="filter-value filter-value-inactive"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 0.4, y: 0 }}
                  exit={{ opacity: 0, y: 20, transition: { damping: 1 } }}
                >
                  {t("filter.any")}
                </motion.div>
              )}
            </>
          )}
        </AnimatePresence>
        <div
          title={expanded ? t("action.close") : t("action.expand")}
          className="toggle-icon"
        >
          <Icon name={expanded ? "chevron-up" : "chevron-down"} />
        </div>
      </button>
      <motion.div
        aria-expanded={expanded}
        animate={{ height: expanded ? "auto" : 0 }}
        className={"filter-collapse"}
      >
        <motion.ul
          role="listbox"
          animate={{
            opacity: expanded ? 1 : 0
          }}
        >
          {Object.entries(data).map(([value, counts]) => (
            <ProductsFiltersItem
              key={value}
              field={filterField}
              value={value}
              unit={settings.specifications?.[filterField]?.unit || ""}
              description={settings.specifications?.[filterField]?.description}
              count={counts.filteredCount}
              totalCount={counts.total}
              activeFilters={activeFilters}
              setFilter={setFilter}
            />
          ))}
        </motion.ul>
      </motion.div>
    </div>
  );
};

export default ProductsFilter;
